import React, { Component } from 'react';
import { PREPAY_REVIEW_URL } from './eir-prepay-constants/ApplicationConstants';
import Constants, { LargeBusiness } from '../Constants';

import EirButton from './eir-button/EirButton';
import SearchOutlined from '@material-ui/icons/Search';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Container,
    Row,
    Nav,
    Col,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu
} from 'reactstrap';
import MegaNavMobile from './header-mobile/MegaNavMobile';
import FocusTrap from 'focus-trap-react';
import EirCart from './eir-cart/EirCart';
import EirBusinessSearch from './eir-search/EirBusinessSearch';
import { isMobileOnly, isTablet } from 'react-device-detect';
import { css } from 'emotion';
class MegaNav extends Component {
    constructor(props) {
        super(props);
        this.burgerTogglerRef = React.createRef(); // Ref for close button

        this.toggle = this.toggle.bind(this);
        this.state = {
            isDropdownOpen: false,
            isBurgerMenuOpen: false,
            isBusinessSite: location.href.indexOf('/business/') > 0 || LargeBusiness.isLBSite,
            isBusinessSmb: location.href.includes('/smb'),
            isBusinessSupport: location.href.includes('/business/support'),
            isPrimaryNavHidden: this.props.props.HidePrimaryNav,
            navigateToHome: this.props.props.logoHomeUrl,
            hostName: location.origin
        };
    }
    componentDidMount() {
        var isIEBrowser = window.navigator.userAgent.indexOf('MSIE') > 0;
        console.log('===123==', Constants.siteTheme.primary);
        document.documentElement.lang = 'en';
        document.documentElement.style.setProperty(
            '--site-primary-theme',
            Constants.siteTheme.primaryTheme
        );
        document.documentElement.style.setProperty(
            '--site-topnav-theme',
            Constants.siteTheme.topNavTheme
        );
        document.documentElement.style.setProperty(
            '--nav-dropdown-right-border-color',
            Constants.siteTheme.navRightBorder
        );
        document.documentElement.style.setProperty(
            '--site-header-logo',
            'url(' + Constants.siteTheme.siteHeaderLogo + ')'
        );
        if (this.state.isBusinessSite) {
            this.setState({ navigateToHome: this.state.navigateToHome });
            if (this.state.isBusinessSmb || this.state.isBusinessSupport) {
                this.setState({ navigateToHome: this.state.hostName + '/business/smb/' });
            }

            // hide "eir home" from primary nav and display on the top nav when its a mobile device and vice-versa when desktop/ipad
            /**********
      switch (true) {
          case (isMobileOnly): {
              let getSiteLink = document.querySelectorAll(".top-left-item");
              for (var i = 0; i < getSiteLink.length; i++) {
                  if (getSiteLink[i].querySelector("a").innerText.toLocaleLowerCase() == "eir home") getSiteLink[i].style.cssText = "display:none !important";//.remove("d-block").add("d-none");
              }
              break;
          }
          case (!isMobileOnly): {
              let getSiteLink = document.querySelectorAll(".top-right-item");
              for (var i = 0; i < getSiteLink.length; i++) {
                  if (getSiteLink[i].innerText.toLocaleLowerCase() == "eir home") getSiteLink[i].style.cssText = "display:none !important";//.remove("d-block").add("d-none");
              }
          }
          default: {
              break;
          }
      }
       */

            //add the theme color to css variable - for the  site theme
            // if (!isIEBrowser && this.props.props.siteTheme.length > 0)
            //     document.documentElement.style.setProperty(
            //         '--site-primary-theme',
            //         this.props.props.siteTheme
            //     );
            // if (!isIEBrowser && this.props.props.topNavTheme.length > 0)
            //     document.documentElement.style.setProperty(
            //         '--site-topnav-theme',
            //         this.props.props.topNavTheme
            //     );
            // //add the theme color to css variable - for the navigation dropdown right border
            // if (!isIEBrowser && this.props.props.siteTheme.length > 0)
            //     document.documentElement.style.setProperty(
            //         '--nav-dropdown-right-border-color',
            //         this.props.props.navDDRtBorderColor
            //     );
            // //add respective site logo to the css variable - for the top left logo in header
            // if (!isIEBrowser && this.props.props.siteHeaderLogo.length > 0)
            //     document.documentElement.style.setProperty(
            //         '--site-header-logo',
            //         'url(' + this.props.props.siteHeaderLogo + ')'
            //     );
            if (!isMobileOnly || isTablet) {
                // single child drop down - restrict the width of the menu dropdown div ---
                let getSingleChildParent = document.querySelectorAll('.child-as-direct-link');
                for (var z = 0; z < getSingleChildParent.length; z++) {
                    getSingleChildParent[z].addEventListener('click', function(e) {
                        let getSingleNodeElement = e.target.parentNode.childNodes;
                        for (var i = 0; i < getSingleNodeElement.length; i++) {
                            if (getSingleNodeElement[i].classList.contains('eir-dropdown-menu')) {
                                var getTargetLeftPosition =
                                    e.target.offsetWidth < 151
                                        ? e.target.offsetLeft - e.target.offsetWidth / 2
                                        : e.target.offsetLeft - 50;
                                var getGrandChild = getSingleNodeElement[i].childNodes;
                                var getGrandChildCount = 0;
                                for (var j = 0; j < getGrandChild.length; j++) {
                                    if (getGrandChild[j].classList.contains('d-md-block')) {
                                        getGrandChildCount = getGrandChild[j].querySelectorAll(
                                            '.row .dropdown-item'
                                        ).length;
                                    }
                                }
                                //appending class to classlist gets overridden - so add as part of inline style
                                getSingleNodeElement[i].style.cssText =
                                    'max-width:300px;margin-left:' +
                                    getTargetLeftPosition +
                                    'px !important;padding:20px 0px;';
                                // console.log(getTargetLeftPosition, e.target.offsetWidth, e.target.offsetWidth)
                            }
                        }
                    });
                }
                // select the first level nav when page loads - show the item as selected
                let getFirstLevelList = document.querySelector('.eir-navbar-nav').childNodes;
                let activePage = getFirstLevelList[0].getAttribute('id');
                for (var i = 0; i < getFirstLevelList.length; i++) {
                    getFirstLevelList[i].addEventListener('click', function(e) {
                        activePage = e.target.parentNode.getAttribute('id');
                        if (activePage != null) {
                            localStorage.setItem('activeMenu', activePage);
                            //set the indicator arrow when the second level menus are dropped down -
                            let getArrowRef = document.querySelector(
                                '#' + activePage + ' .nav-link'
                            );
                            let setArrowIndicator =
                                getArrowRef.offsetWidth / 2 + getArrowRef.offsetLeft;
                            if (!isIEBrowser)
                                document.documentElement.style.setProperty(
                                    '--arrow-indicator-position',
                                    setArrowIndicator + 'px'
                                );
                            if (!isIEBrowser)
                                document.documentElement.style.setProperty(
                                    '--business-nav-dropdown-parent',
                                    getArrowRef.clientWidth <= 130 ? '-3rem' : '-5rem'
                                );
                        }
                    });
                }

                /* make the respective primary nav menu item selected  - the resp json files are under /json in opencms*/

                let getNavItemMappingJSON =
                    location.href.indexOf('/lb/') > 0
                        ? '/json/business-nav-lb.txt'
                        : '/json/business-nav-smb.txt';
                let menuToBeSelected = '';

                !LargeBusiness.isLBSite
                    ? fetch(getNavItemMappingJSON)
                          .then(response => {
                              return response.json();
                          })
                          .then(data => {
                              // Work with JSON data here
                              var urlValue = location.href;
                              for (var i = 0; i < data.primaryNavItems.length; i++) {
                                  var obj = data.primaryNavItems[i];
                                  for (var key in obj) {
                                      var keyValues = obj[key];
                                      for (var j = 0; j < keyValues.length; j++) {
                                          if (urlValue.indexOf(keyValues[j]) > 0) {
                                              menuToBeSelected = key;
                                          }
                                      }
                                  }
                              }
                              var navItem = document.querySelector('.eir-navbar-nav').childNodes;
                              for (i = 0; i < navItem.length; i++) {
                                  if (navItem[i].childNodes[0].innerHTML === menuToBeSelected) {
                                      navItem[i].childNodes[0].style.cssText =
                                          'text-decoration:underline !important';
                                  }
                              }
                          })
                          .catch(err => {
                              console.log(
                                  'Error in loading the navigation for highlighting menu - ',
                                  err
                              );
                          })
                    : '';
            }
            // if (!isIEBrowser && window.innerWidth < 768) document.documentElement.style.setProperty('--arrow-indicator-position', setArrowIndicator + "px");
        } else {
            this.setState({ navigateToHome: this.state.hostName });
        }

        /*the below is for the consumer site - setting theme color - this is temp as once the top nav styling also is 
    brought in for consumer - then we can have the above if condition only by removing is business --- 
    */
        // else {
        //     //add the theme color to css variable - for the  site theme
        //     if (!isIEBrowser && this.props.props.siteTheme.length > 0)
        //         document.documentElement.style.setProperty(
        //             '--site-primary-theme',
        //             this.props.props.siteTheme
        //         );
        //     if (!isIEBrowser && this.props.props.topNavTheme.length > 0)
        //         document.documentElement.style.setProperty(
        //             '--site-topnav-theme',
        //             this.props.props.topNavTheme
        //         );
        //     //add the theme color to css variable - for the navigation dropdown right border
        //     if (!isIEBrowser && this.props.props.siteTheme.length > 0)
        //         document.documentElement.style.setProperty(
        //             '--nav-dropdown-right-border-color',
        //             this.props.props.navDDRtBorderColor
        //         );
        //     //add respective site logo to the css variable - for the top left logo in header
        //     if (!isIEBrowser && this.props.props.siteHeaderLogo.length > 0)
        //         document.documentElement.style.setProperty(
        //             '--site-header-logo',
        //             'url(' + this.props.props.siteHeaderLogo + ')'
        //         );
        // }
    }

    toggle() {
        this.setState({
            isDropdownOpen: !this.state.isDropdownOpen,
            isBurgerMenuOpen: !this.state.isBurgerMenuOpen
        });
    }

    getBurgerMenuClassNames() {
        if (!this.state.isBurgerMenuOpen) {
            return LargeBusiness.isLBSite ? 'hamburger-icon' : 'm01-header__burger__btn';
        } else {
            return LargeBusiness.isLBSite
                ? 'menu-close-icon'
                : 'm01-header__burger__btn m01-header__burger__btn--open';
        }
    }
    render() {
        const { props } = this.props;
        const headerLogoURL = this.props.props.siteHeaderLogo;
        const containerName = LargeBusiness.isLBSite ? 'lb-meganav-container' : 'meganav-container';
        let cartURL = localStorage.getItem('prospectUuid')
            ? PREPAY_REVIEW_URL
            : '/checkout/order-summary/';

        if (
            localStorage.getItem('eir_upgrade_check') != null &&
            localStorage.getItem('eir_prequal_order') != null
        ) {
            if (localStorage.getItem('eir_be_data') != null) {
                const eirBeData = JSON.parse(localStorage.getItem('eir_be_data'));
                cartURL = eirBeData.order.mobileUpgrade ? '/store/shopping-basket/' : cartURL;
            } else {
                cartURL = '/store/shopping-basket';
            }
        }
        if (
            localStorage.getItem('ACQ_PROSPECTUUID') ||
            localStorage.getItem('CO_REF') ||
            localStorage.getItem('CS_REF')
        ) {
            if (
                localStorage.getItem('ACQ_HANDSET_BE_OFFERID') === null ||
                localStorage.getItem('ACQ_HANDSET_BE_OFFERID') === ''
            ) {
                cartURL = '/shop/redirectSummary';
            }
        }
        console.log('cartURL in meganav :', cartURL);
        return (
            <Container
                fluid
                className={
                    this.state.isPrimaryNavHidden === 'true'
                        ? `d-none ${containerName} p-0 `
                        : `${containerName} p-0 `
                }>
                <Container className="p-0">
                    <Navbar expand="md" role="none">
                        <div className="d-flex eir-navbar-items">
                            <div className="d-flex eir-navbar-top-items " role="banner">
                                {/* header logo */}
                                {!(
                                    headerLogoURL != undefined &&
                                    headerLogoURL.lastIndexOf('.svg') > 0
                                ) ? (
                                    <a
                                        href={this.state.navigateToHome}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                window.location.href = this.state.navigateToHome;
                                            }
                                        }}
                                        aria-label="Eir go back to homepage">
                                        <div
                                            className={
                                                'eir-navbar-brand text-left ' +
                                                (headerLogoURL != undefined && headerLogoURL != ''
                                                    ? css`
                                                          background-image: url(${headerLogoURL}) !important;
                                                      `
                                                    : '')
                                            }
                                            role="img"
                                            aria-label="Eir go back to homepage"
                                        />
                                    </a>
                                ) : (
                                    <a
                                        href={this.state.navigateToHome}
                                        aria-label="Eir go back to homepage">
                                        <object
                                            data={headerLogoURL}
                                            type={'image/svg+xml'}
                                            className="eir-navbar-brand-svg"
                                        />
                                    </a>
                                )}
                            </div>

                            {/* Navbar Items */}

                            <Collapse
                                isOpen={this.state.isDropdownOpen}
                                navbar
                                className="burger-collapse">
                                <FocusTrap
                                    active={this.state.isDropdownOpen}
                                    focusTrapOptions={{
                                        fallbackFocus: '#burgerMenuTrapWrapper',
                                        escapeDeactivates: true,
                                        clickOutsideDeactivates: true,
                                        returnFocusOnDeactivate: true
                                    }}>
                                    <div id="burgerMenuTrapWrapper" style={{ display: 'contents' }}>
                                        <Nav
                                            className="eir-navbar-nav justify-content-around"
                                            navbar>
                                            {/* Primary Nav List  */}
                                            {props.primaryNav.children.map((navItem, index) => {
                                                if (navItem.title !== undefined) {
                                                    return (
                                                        // <div key={index}>

                                                        <UncontrolledDropdown
                                                            id={'first-level-' + index}
                                                            nav
                                                            inNavbar
                                                            className={
                                                                navItem.children.length < 2
                                                                    ? 'menu text-right  has-child child-as-direct-link'
                                                                    : 'menu text-right has-child'
                                                            }
                                                            key={index}>
                                                            {/* Navbar Link Name */}
                                                            <DropdownToggle
                                                                nav
                                                                caret
                                                                className="pt-4 pb-4  m-0 pt-md-0 pb-md-0 mt-md-4 pb-0 text-nowrap text-left">
                                                                {navItem.title}
                                                            </DropdownToggle>
                                                            {/* dropdown menu */}
                                                            <DropdownMenu
                                                                // role='link'
                                                                className={
                                                                    this.state.isBusinessSite
                                                                        ? 'eir-dropdown-menu w-100 m-0 container'
                                                                        : 'eir-dropdown-menu w-100 m-0'
                                                                }>
                                                                <Container className="d-none d-md-block">
                                                                    <Row>
                                                                        {navItem.image !==
                                                                            undefined &&
                                                                            (!this.state
                                                                                .isBusinessSite ||
                                                                                LargeBusiness.isLBSite) && (
                                                                                <Col
                                                                                    md="4"
                                                                                    className="featured">
                                                                                    <div className="title">
                                                                                        <a
                                                                                            href=""
                                                                                            style={{
                                                                                                color:
                                                                                                    'inherit',
                                                                                                pointerEvents:
                                                                                                    'none',
                                                                                                textDecoration:
                                                                                                    'none'
                                                                                            }}
                                                                                            onClick={e =>
                                                                                                e.preventDefault()
                                                                                            }
                                                                                            onKeyDown={e => {
                                                                                                if (
                                                                                                    e.key ===
                                                                                                        'Enter' ||
                                                                                                    e.key ===
                                                                                                        ' '
                                                                                                ) {
                                                                                                    e.preventDefault();
                                                                                                }
                                                                                            }}>
                                                                                            {' '}
                                                                                            {
                                                                                                navItem.title
                                                                                            }
                                                                                        </a>
                                                                                    </div>
                                                                                    <div className="subTitle">
                                                                                        Featured
                                                                                    </div>
                                                                                    <a
                                                                                        href={
                                                                                            navItem.link
                                                                                                ? navItem
                                                                                                      .link
                                                                                                      .link
                                                                                                : ''
                                                                                        }>
                                                                                        <img
                                                                                            src={
                                                                                                navItem
                                                                                                    .image
                                                                                                    .path
                                                                                            }
                                                                                            alt={
                                                                                                navItem
                                                                                                    .image
                                                                                                    .description
                                                                                            }
                                                                                            className="img-fluid w3-animate-opacity"
                                                                                        />
                                                                                    </a>
                                                                                </Col>
                                                                            )}
                                                                        {navItem.children.map(
                                                                            (item, index) => {
                                                                                return (
                                                                                    <Col
                                                                                        key={index}
                                                                                        className="dropdown-items">
                                                                                        <div
                                                                                            className={
                                                                                                item.title ===
                                                                                                    null ||
                                                                                                item.title ===
                                                                                                    undefined
                                                                                                    ? 'd-none'
                                                                                                    : 'title'
                                                                                            }>
                                                                                            {this
                                                                                                .state
                                                                                                .isBusinessSite &&
                                                                                                item.icon !=
                                                                                                    null && (
                                                                                                    <span className="dropdown-item-head-icon">
                                                                                                        <img
                                                                                                            src={
                                                                                                                item.icon
                                                                                                            }
                                                                                                            alt={
                                                                                                                item.title
                                                                                                            }
                                                                                                            title={
                                                                                                                item.title
                                                                                                            }
                                                                                                        />
                                                                                                    </span>
                                                                                                )}
                                                                                            {/* the first level child title may or maynot be a hyper link - EIRZWM-574 */}
                                                                                            {item.link !=
                                                                                                undefined &&
                                                                                            item
                                                                                                .link
                                                                                                .link
                                                                                                .length >
                                                                                                0 ? (
                                                                                                <a
                                                                                                    title={
                                                                                                        item
                                                                                                            .link
                                                                                                            .title !=
                                                                                                        undefined
                                                                                                            ? item
                                                                                                                  .link
                                                                                                                  .title
                                                                                                            : item.title
                                                                                                    }
                                                                                                    href={
                                                                                                        item
                                                                                                            .link
                                                                                                            .link
                                                                                                    }>
                                                                                                    {
                                                                                                        item.title
                                                                                                    }
                                                                                                </a>
                                                                                            ) : (
                                                                                                <a
                                                                                                    href=""
                                                                                                    style={{
                                                                                                        color:
                                                                                                            'inherit',
                                                                                                        pointerEvents:
                                                                                                            'none',
                                                                                                        textDecoration:
                                                                                                            'none'
                                                                                                    }}
                                                                                                    onClick={e =>
                                                                                                        e.preventDefault()
                                                                                                    }
                                                                                                    onKeyDown={e => {
                                                                                                        if (
                                                                                                            e.key ===
                                                                                                                'Enter' ||
                                                                                                            e.key ===
                                                                                                                ' '
                                                                                                        ) {
                                                                                                            e.preventDefault();
                                                                                                        }
                                                                                                    }}>
                                                                                                    {
                                                                                                        item.title
                                                                                                    }{' '}
                                                                                                </a>
                                                                                            )}
                                                                                        </div>
                                                                                        {item.children.map(
                                                                                            (
                                                                                                child,
                                                                                                index
                                                                                            ) => {
                                                                                                return (
                                                                                                    <div
                                                                                                        key={
                                                                                                            index
                                                                                                        }
                                                                                                        className="dropdown-item">
                                                                                                        <a
                                                                                                        aria-label={child
                                                                                                                        .link
                                                                                                                        .ariaLabel || undefined}
                                                                                                            href={
                                                                                                                child
                                                                                                                    .link
                                                                                                                    .link
                                                                                                            }
                                                                                                            dangerouslySetInnerHTML={{
                                                                                                                __html:
                                                                                                                    child
                                                                                                                        .link
                                                                                                                        .title
                                                                                                            }}
                                                                                                            
                                                                                                        />
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                    </Col>
                                                                                );
                                                                            }
                                                                        )}
                                                                    </Row>
                                                                </Container>
                                                                <Container className="d-block d-md-none">
                                                                    <MegaNavMobile {...navItem} />
                                                                </Container>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                        // </div>
                                                    );
                                                } else {
                                                    const navLinkClasses = `pt-4 pb-4  m-0 pt-md-0 pb-md-0 mt-md-4 pb-0 text-left ${
                                                        LargeBusiness.isLBSite ? 'text-nowrap' : ''
                                                    }`;
                                                    return navItem.link.text == 'Contact-btn' ? (
                                                        // contact btn
                                                        <NavItem
                                                            id={'first-level-single-' + index}
                                                            className="contact-us-button menu"
                                                            key={index}>
                                                            <EirButton
                                                                text={'Contact'}
                                                                title={'Contact'}
                                                                buttonStyle={'color-shadow'}
                                                                buttonSize={'large'}
                                                                link={navItem.link.link}
                                                                theme={'light'}>
                                                                {' '}
                                                                Contact{' '}
                                                            </EirButton>
                                                            <NavLink
                                                                href={navItem.link.link}
                                                                className={navLinkClasses}>
                                                                {navItem.link.title}
                                                            </NavLink>
                                                        </NavItem>
                                                    ) : // search btn
                                                    navItem.link.text == 'Search-btn' ? (
                                                        <NavItem
                                                            id={'first-level-single-' + index}
                                                            className="header-search-icon menu">
                                                            <SearchOutlined />
                                                        </NavItem>
                                                    ) : (
                                                        // Normal Nav Link
                                                        <NavItem
                                                            id={'first-level-single-' + index}
                                                            key={index}
                                                            className="menu">
                                                            <NavLink
                                                                href={navItem.link.link}
                                                                className={navLinkClasses}>
                                                                {navItem.link.title}
                                                            </NavLink>
                                                        </NavItem>
                                                    );
                                                }
                                            })}
                                            {/* Secondary Nav List */}
                                            {!LargeBusiness.isLBSite
                                                ? props.secondaryNavLeft.children.map(
                                                      (navItem, index) => {
                                                          return (
                                                              <NavItem
                                                                  key={index}
                                                                  id={'top-nav-' + index}
                                                                  className="menu d-block d-md-none top-left-item">
                                                                  <NavLink
                                                                      href={navItem.link.link}
                                                                      aria-label={navItem.link.ariaLabel || undefined}
                                                                      className="pt-4 pb-4  m-0 pt-md-0 pb-md-0 mt-md-4 pb-0 text-left">
                                                                      {navItem.link.title}
                                                                  </NavLink>
                                                              </NavItem>
                                                          );
                                                      }
                                                  )
                                                : ''}
                                        </Nav>
                                        <div
                                            tabIndex="0"
                                            className="focus-trap-exit"
                                            onFocus={() => {
                                                this.setState(
                                                    {
                                                        isDropdownOpen: false,
                                                        isBurgerMenuOpen: false
                                                    },
                                                    () => {
                                                        if (
                                                            this.burgerTogglerRef &&
                                                            this.burgerTogglerRef.current
                                                        ) {
                                                            this.burgerTogglerRef.current.focus();
                                                        }
                                                    }
                                                );
                                            }}
                                            style={{
                                                width: 0,
                                                height: 0,
                                                overflow: 'hidden',
                                                position: 'absolute'
                                            }}
                                        />
                                    </div>
                                </FocusTrap>
                            </Collapse>
                            <div className="d-flex cartItems">
                                {/* Cart Logo display only for eir.ie site */}
                                {!LargeBusiness.isLBSite && !this.state.isBusinessSite ? (
                                    <NavLink
                                        href={cartURL}
                                        className="icon-link nav-item pr-0"
                                        aria-label="My Cart"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                window.location.href = cartURL;
                                            }
                                        }}>
                                        <EirCart />
                                    </NavLink>
                                ) : (
                                    <EirBusinessSearch />
                                )}

                                {/* Navbar Toggle button */}
                                <NavbarToggler
                                    className="m01-header__burger"
                                    onClick={this.toggle}
                                    aria-label={
                                        this.state.isBurgerMenuOpen ? 'Close Menu' : 'burger-menu'
                                    }
                                    type="Navigation"
                                    role="navigation">
                                    <a
                                        ref={this.burgerTogglerRef}
                                        className={this.getBurgerMenuClassNames()}>
                                        <span />
                                        <span />
                                        <span />
                                        <span />
                                    </a>
                                </NavbarToggler>
                            </div>
                        </div>
                    </Navbar>
                </Container>
            </Container>
        );
    }
}

export default MegaNav;
